module.exports = __webpack_public_path__ + "static/image02-800-cd4db15b381c9ad2c7f4155ab2ef79a7.jpg";